import { useQuery } from '@tanstack/react-query';

import regularStatus from '../../regular/status';
import fetch from './fetch';

function useMtAccountStatus() {
  const { cb, key } = fetch();

  const { isMtActive } = regularStatus.useAccountStatus();

  const enabled = isMtActive; // Do not call when user does not have MT account

  const { data, isSuccess, refetch } = useQuery(key, cb, { enabled });

  const isMtBuySuspended = data?.stock_mt?.status_trade_buy === 'SUSPEND_BUY';
  const isMtSellSuspended = data?.stock_mt?.status_trade_sell === 'SUSPEND_SELL';

  return { data, isSuccess, refetch, isMtActive, isMtBuySuspended, isMtSellSuspended };
}

export default {
  useMtAccountStatus,
};
